<template>
  <BaseLayout id="app">
    <Toast
    v-model="commonStore.getToast.showToast"
    :message="commonStore.getToast.message"
    :state="commonStore.getToast.state"
    :timeout="commonStore.getToast.timeout"
  />
  <!-- データ更新中 -->
  <Toast
    v-model="commonStore.getupDatingToast.showToast"
    :message="commonStore.getupDatingToast.message"
    :state="commonStore.getupDatingToast.state"
    :timeout="commonStore.getupDatingToast.timeout"
    :style="[commonStore.getToast.showToast ? 'top: 70px;' : 'top: 10px;']"
  />
    <slot><router-view /></slot>
  </BaseLayout>
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import BaseLayout from "./components/BaseLayout.vue";
import { CommonStore } from "./store/CommonStore"
import Toast from "./components/Toast.vue";

const commonStore = CommonStore()

</script>

<style lang="scss">
@import "assets/style/_variables.scss";
@import "assets/style/_mixin.scss";
#app {
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  font-family: $font-family-hiragino-gothic-pron;
  font-style: normal;
}

</style>
